var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.000000, -9.000000)",
    fill: "#3C3C3B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1819805,10.9038059 C17.7342653,10.9038059 18.1819805,11.3515212 18.1819805,11.9038059 L18.1819805,15.9038059 C18.1819805,16.2107377 18.0437005,16.4853724 17.8260404,16.6688102 C17.6422267,16.8868462 17.3675919,17.0251263 17.0606602,17.0251263 L13.0606602,17.0251263 C12.5083754,17.0251263 12.0606602,16.577411 12.0606602,16.0251263 C12.0606602,15.4728415 12.5083754,15.0251263 13.0606602,15.0251263 L16.1816602,15.0248059 L16.1819805,11.9038059 C16.1819805,11.3515212 16.6296958,10.9038059 17.1819805,10.9038059 Z",
    id: "Combined-Shape",
    transform: "translate(15.121320, 13.964466) rotate(-315.000000) translate(-15.121320, -13.964466) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCollapse);
export default __webpack_public_path__ + "static/media/menu_collapse.8a1462c4e0840a2e8c7eba39fbfa1e8a.svg";
export { ForwardRef as ReactComponent };